import { render, staticRenderFns } from "./mode1.vue?vue&type=template&id=00766993&scoped=true"
import script from "./mode1.vue?vue&type=script&lang=js"
export * from "./mode1.vue?vue&type=script&lang=js"
import style0 from "./mode1.vue?vue&type=style&index=0&id=00766993&prod&lang=scss"
import style1 from "./mode1.vue?vue&type=style&index=1&id=00766993&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00766993",
  null
  
)

export default component.exports